import types from '../../constants';

const initialState = {
  loading: false,
  data: {},
  isEdit: false,
  errors: {},
};

const CompanyReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.COMPANY_LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case types.COMPANY_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case types.COMPANY_CLEAR:
      return {
        ...state,
        data: {},
      };
    case types.COMPANY_FETCH:
      return {
        ...state,
        data: action.payload,
      };
    case types.COMPANY_SET_IS_EDIT:
      return {
        ...state,
        isEdit: action.payload,
      };
    case types.COMPANY_CHANGE_FORM:
      const newState = {
        ...state,
      };

      newState.data = { ...state.data };
      newState.data[action.payload.field] = action.payload.value;

      return newState;
    case types.COMPANY_SET_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default CompanyReducers;
